// src/@types/filter.types.ts
var SortOptions = /* @__PURE__ */ ((SortOptions2) => {
  SortOptions2["asc"] = "asc";
  SortOptions2["desc"] = "desc";
  return SortOptions2;
})(SortOptions || {});
var SortButtonMode = /* @__PURE__ */ ((SortButtonMode2) => {
  SortButtonMode2["TOGGLE_DEFAULT"] = "toggle-default";
  SortButtonMode2["TOGGLE_NO_DEFAULT"] = "toggle-no-default";
  return SortButtonMode2;
})(SortButtonMode || {});

export { SortButtonMode, SortOptions };
